import { useMutation } from '@apollo/client';
import { CREATE_NCR_FROM_NCR_TEMPLATE } from '../operations/mutations/createNCRFromNCRTemplate';

export const useCreateNCRFromNCRTemplate = () => {
    const [createNCRFromNCRTemplate, { data, loading: loadingCreateNCRFromNCRTemplate, error }] = useMutation(CREATE_NCR_FROM_NCR_TEMPLATE);

    return [createNCRFromNCRTemplate, { data, loadingCreateNCRFromNCRTemplate, error }];
};
